import React, { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from 'antd';
import { regionChanged } from 'containers/MainLayout/actions';
import styled from 'styled-components';
import Button from '../../components/Button/Button';
import media from 'utils/mediaStyle';
import isGoogleBot from 'utils/urls/isGoogleBot';
import messages from 'utils/messages';
import { FormattedMessage } from 'react-intl';

const CustomModal = styled(Modal)`
  .ant-modal-content {
    width: 100%;
  }

  ${media.md`
    .ant-modal-content {
      width: 411px;
      margin: 0 auto;
    }
  `}
`;

const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TitleModal = styled.div`
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: #242527;
  text-align: center;
`;

const SelectWrapper = styled.div`
  width: 100%;
  margin-top: 12px;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
`;

const DescriptionModal = styled.div`
  margin-top: 4px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #242527;
  text-align: center;
`;
const RegionButton = styled(Button)`
  font-size: 16px;
  font-weight: 500;
  width: 100%;
  flex: 1;
  height: 48px;
  line-height: 46px;

  &.isSelected {
    color: #4b9c63 !important;
    border: 1px solid #4b9c63 !important;
    background-color: #f0f9f1 !important;
  }
`;

const ButtonConfirmModal = styled(Button)`
  padding: 12px auto;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  width: 100%;
  height: 48px;
  line-height: 46px;
`;

const SelectRegionModal: FC = () => {
  const [region, setRegion] = useState('HCM');
  // State (không đọc localStorage mỗi render): khi confirm không reload nữa,
  // phải tự set để modal đóng (open={!hasRegion}).
  const [hasRegion, setHasRegion] = useState(() => !!localStorage.getItem('region'));
  const dispatch = useDispatch();

  const onChange = (value) => {
    setRegion(value);
  };

  const onConfirm = () => {
    window.localStorage.setItem('region', region);
    setHasRegion(true);
    if (window.location.pathname === '/') {
      dispatch(regionChanged(region));
    } else {
      window.location.reload();
    }
  };

  return (
    <CustomModal open={!hasRegion && !isGoogleBot()} closable={false} footer={false} centered>
      <ModalWrapper center={true}>
        <TitleModal>
          <FormattedMessage {...messages.selectRegionToViewPrices} defaultMessage="Chọn khu vực để xem giá" />
        </TitleModal>
        <DescriptionModal>
          <FormattedMessage
            {...messages.getTheBestPriceForYourBusiness}
            defaultMessage="Nhận giá tốt nhất cho doanh nghiệp của bạn"
          />
        </DescriptionModal>
        <SelectWrapper>
          <RegionButton className={region === 'HN' ? 'isSelected' : ''} onClick={() => onChange('HN')}>
            <FormattedMessage {...messages.northern} defaultMessage="Miền Bắc" />
          </RegionButton>
          <RegionButton className={region === 'HCM' ? 'isSelected' : ''} onClick={() => onChange('HCM')}>
            <FormattedMessage {...messages.southern} defaultMessage="Miền Nam" />
          </RegionButton>
        </SelectWrapper>
        <ButtonConfirmModal type="bg-primary" onClick={onConfirm}>
          <FormattedMessage {...messages.continue} defaultMessage="Tiếp tục" />
        </ButtonConfirmModal>
      </ModalWrapper>
    </CustomModal>
  );
};

export default SelectRegionModal;
